var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"id":"app"}},[_c('div',{attrs:{"id":"background"}}),_c('div',{staticClass:"cover-container d-flex h-100 p-3 mx-auto flex-column"},[_c('Header'),_c('router-view'),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }